export const CustomRegisterForm = "CustomRegisterForm";
export const ParentNameActivity = "Activity";

export enum CustomerStatus { Active = 0, Temp = 1 }

export enum LevelProvider { Pandora = 0, WPR = 1 }
